import * as http from 'axios'

export const getAgendaPorProfissional = (profissional) => {
  return http.get(`/agenda/dias?corpo_clinico=${profissional._id}`)
}
export const confirmarAgendamento = (agendamento) => {
  return http.post(`/agendamento/${agendamento._id}/confirmar`)
}
export const cancelarAgendamento = (agendamento) => {
  return http.post(`/agendamento/${agendamento._id}/cancelar`)
}

export const getAgendaPorProfissionalCompleta = (profissional) => {
  return http.get(`/agenda/diasCompleta?corpo_clinico=${profissional._id}`)
}



// WEBPACK FOOTER //
// ./src/store/gerenciarAgendamento/services.js